import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigate"
// On change->navigate#to: merges query params from the frame src (or page URL), sets src.
export default class extends Controller {
  to(event) {
    const value = event.target.value
    if (!value) return

    const paramName = event.target.dataset.param || "value"
    const pathTemplate = event.target.dataset.url
    const url = this.#navUrl({ paramName, paramValue: value, pathTemplate })
    this.element.src = url.toString()
  }

  #paramsSourceUrl() {
    const frameSrc = this.element.getAttribute("src")
    if (frameSrc) return new URL(frameSrc, window.location.origin)
    return new URL(window.location.href)
  }

  #navUrl({ paramName, paramValue, pathTemplate }) {
    const pathAndQuery =
      pathTemplate || `${window.location.pathname}${window.location.search}`
    const url = new URL(pathAndQuery, window.location.origin)
    this.#paramsSourceUrl().searchParams.forEach((v, k) => {
      url.searchParams.set(k, v)
    })
    url.searchParams.set(paramName, paramValue)
    return url
  }
}
